import { apiCall } from './gqlClient';

const GETCUSTOMERPROVIDERRECORDS_QUERY = `
  query getCustomerProviderRecords($customerId: Int!) {
    getCustomerProviderRecords(customerId: $customerId)
    {
      id
			title
			description
			category
			priority
			fileCreated
			dueDate
			questions
			steps
      ...fragments
    }
  }`;

export const getCustomerProviderRecordsApiCall = async ({customerId}, fragments = null) => apiCall({ query: GETCUSTOMERPROVIDERRECORDS_QUERY, variables: {customerId}, fragments });

const SAVECUSTOMERPROVIDERRECORD_QUERY = `
  mutation saveCustomerProviderRecord($record: customerProviderRecordInput!) {
    saveCustomerProviderRecord(record: $record)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const saveCustomerProviderRecordApiCall = async ({record}, fragments = null) => apiCall({ query: SAVECUSTOMERPROVIDERRECORD_QUERY, variables: {record}, fragments });

const ADDFILETORECORD_QUERY = `
  mutation addFileToRecord($file: customerProviderRecordFileInput!) {
    addFileToRecord(file: $file)
    {
      id
			copyId
			presignedUrl
			presignedUrls
			signedUrl
			success
			name
			sectionIndex
			type
			signatureFileId
      ...fragments
    }
  }`;

export const addFileToRecordApiCall = async ({file}, fragments = null) => apiCall({ query: ADDFILETORECORD_QUERY, variables: {file}, fragments });

const UPDATECUSTOMERPROVIDERRECORD_QUERY = `
  mutation updateCustomerProviderRecord($record: customerProviderRecordInput!) {
    updateCustomerProviderRecord(record: $record)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateCustomerProviderRecordApiCall = async ({record}, fragments = null) => apiCall({ query: UPDATECUSTOMERPROVIDERRECORD_QUERY, variables: {record}, fragments });

const TOGGLERECORDPRIORITY_QUERY = `
  mutation toggleRecordPriority($recordId: String!, $status: Boolean!) {
    toggleRecordPriority(recordId: $recordId, status: $status)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const toggleRecordPriorityApiCall = async ({recordId, status}, fragments = null) => apiCall({ query: TOGGLERECORDPRIORITY_QUERY, variables: {recordId, status}, fragments });

const DELETECUSTOMERPROVIDERRECORD_QUERY = `
  mutation deleteCustomerProviderRecord($id: String!) {
    deleteCustomerProviderRecord(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteCustomerProviderRecordApiCall = async ({id}, fragments = null) => apiCall({ query: DELETECUSTOMERPROVIDERRECORD_QUERY, variables: {id}, fragments });

const REMOVEFILEFROMRECORD_QUERY = `
  mutation removeFileFromRecord($fileId: String!) {
    removeFileFromRecord(fileId: $fileId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const removeFileFromRecordApiCall = async ({fileId}, fragments = null) => apiCall({ query: REMOVEFILEFROMRECORD_QUERY, variables: {fileId}, fragments });
